module.exports = __webpack_public_path__ + "28ffc9533b958294404ea4aa159ddb9b.svg";